<template>
  <transition :name="collapsed ? 'slide-collapsed' : 'slide'">
    <nav
      v-click-outside="vcoConfig"
      v-show="active"
      :class="collapsed ? 'translate-x-16' : 'translate-x-full'"
      class="bg-ontick-graphite-500 absolute top-0 z-20 h-full max-h-screen w-64 transform-gpu space-y-6 overflow-y-auto pt-16 pl-4 shadow-lg transition-all duration-500 ease-in-out"
    >
      <span class="font-semibold"> Parceiros ativados </span>
      <ul>
        <li v-for="extension in extensions" :key="extension.extension_id" @click="$emit('close')">
          <router-link
            class="flex items-center space-x-4 py-2"
            :to="{
              name: 'Estratégias de parceiro',
              params: {
                partner_name: extension.extension_path,
                extension_id: extension.extension_id,
              },
            }"
          >
            <img :src="extension.extension_logo" :alt="extension.extension_name" class="h-5 w-5" />
            <span>
              {{ extension.extension_name }}
            </span>
          </router-link>
        </li>
      </ul>
    </nav>
  </transition>
</template>

<script>
// import clickOutside from "vue-click-outside";

export default {
  // directives: {
  //   clickOutside,
  // },

  props: {
    extensions: {
      type: Array,
    },
    collapsed: {
      type: Boolean,
    },
    active: {
      type: Boolean,
    },
  },

  computed: {
    vcoConfig() {
      return {
        handler: this.close,
        active: this.active,
      };
    },
  },

  methods: {
    close() {
      if (this.active) {
        // console.log("close");
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.slide {
  &-enter-active,
  &-leave-active {
    @apply transform-gpu transition-all duration-500 ease-in-out;
  }
  &-enter,
  &-leave-to {
    @apply translate-x-0 opacity-0;
  }
  &-enter-to,
  &-leave {
    @apply translate-x-full opacity-100;
  }
}
.slide-collapsed {
  &-enter-active,
  &-leave-active {
    @apply transform-gpu transition-all duration-500 ease-in-out;
  }
  &-enter,
  &-leave-to {
    @apply translate-x-0 opacity-0;
  }
  &-enter-to,
  &-leave {
    @apply translate-x-16 opacity-100;
  }
}
</style>
